export function reportSubmissionsStatus (statusNumber) {
  switch (statusNumber) {
    case 0:
      return 'new'
    case 1:
      return 'unfinished'
    case 2:
      return 'accepted'
    case 3:
      return 'sent'
    case 4:
      return 'rejected'
    case 5:
      return 'accepted'
    case 6:
      return 'error'
  }
  return 'new'
}

export function reportSubmissionGroupStatus (statusNumber) {
  switch (statusNumber) {
    case 0:
      return 'new'
    case 1:
      return 'unfinished'
    case 2:
      return 'sent'
    case 3:
      return 'rejected'
    case 4:
      return 'accepted'
  }
  return 'new'
}

export function reportSubmissionCheckingRuleStatus (statusNumber) {
  switch (statusNumber) {
    case 0:
      return 'error'
    case 1:
      return 'warning'
    case 2:
      return 'information'
    case 3:
      return 'invalidExpression'
    case 4:
      return 'succeeded'
    case 5:
      return 'notChecked'
    case 6:
      return 'information'
  }
}



// WEBPACK FOOTER //
// ./src/components/reporting/submissions/reportSubmissionsStatus.js